import { DetailPanel } from '../components/DetailPanel';

export interface ComingSoonPageProps {
  title: string;
  phase: number;
}

/**
 * Side uden indhold endnu (docs/UX.md afsnit 3, "Uden navigation"):
 * intet venstrepanel, kun ét panelhoved i fuld bredde som Borgeres
 * (blåt, uden tæller eller knapper) med sidenavnet som titel og
 * "Kommer i fase N" som undertitel, efterfulgt af en tomtilstand
 * (UI-look-audit brief 4b.5).
 */
export function ComingSoonPage({ title, phase }: ComingSoonPageProps) {
  return (
    <div className="page">
      <div className="page-body flush">
        <DetailPanel title={title} subtitle={`Kommer i fase ${phase}`}>
          <div className="empty-state">
            <span className="empty-state-icon" aria-hidden="true">
              🚧
            </span>
            <p className="empty-state-text">Siden er endnu ikke bygget.</p>
          </div>
        </DetailPanel>
      </div>
    </div>
  );
}
